/**
 * Pricing period switch (monthly / yearly).
 *
 * Deliberately tiny: the template cannot write x-data="{ period: 'primary' }" inline, because Fluid
 * would try to parse the curly braces as one of its own expressions. Registering the component here
 * keeps the markup free of braces - the same reason Transformation and Hotspot have components.
 *
 * Both prices are in the DOM; the inactive one carries the [hidden] attribute, so it is out of the
 * accessibility tree and a screen reader never announces two prices for one plan.
 */
document.addEventListener('alpine:init', () => {
    Alpine.data('pricingPeriod', () => ({
        period: 'primary',
    }));
});
